/* eslint-disable import/no-anonymous-default-export */
import * as actions from './actions';

export type State = {
    loading: boolean;
    incomeEvents?: Record<string, any>;
    expenseEvents?: Record<string, any>;
    error: object;
    tempScenario: Record<string, any>;
    modelledScenario?: Record<string, any>;
    updatedFields: Record<string, any>;
};

// export default (
//   state: State = {
//     loading: false,
//     incomeEvents: [],
//     expenseEvents: [],
//     error: {},
//   },
//   action: any = {},
// ): State => {
//   switch (action.type) {
//     case actions.FETCH_INCOME_EVENTS:
//       return {
//         ...state,
//         loading: true,
//       };
//     case actions.FETCH_INCOME_EVENTS_SUCCESS:
//       return {
//         ...state,
//         incomeEvents: action.payload,
//       };
//     case actions.FETCH_INCOME_EVENTS_ERROR:
//       return {
//         ...state,
//         error: action.payload,
//       };
//     case actions.FETCH_EXPENSE_EVENTS:
//       return {
//         ...state,
//         loading: true,
//       };
//     case actions.FETCH_EXPENSE_EVENTS_SUCCESS:
//       const expenseEventsContent =
//         action.payload &&
//         action.payload.map((ee: any) => {
//           return {
//             value: ee.elements.sourceValue.value,
//             name: ee.elements.sourceDisplayName.value,
//           };
//         });

//       return {
//         ...state,
//         expenseEvents: expenseEventsContent,
//       };
//     case actions.FETCH_EXPENSE_EVENTS_ERROR:
//       return {
//         ...state,
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export default (
    state: State = {
        loading: false,
        incomeEvents: {},
        expenseEvents: {},
        error: {},
        tempScenario: {},
        modelledScenario: {},
        updatedFields: {},
    },
    action: any,
): State => {
    switch (action.type) {
    //         case actions.FETCH_INCOME_EVENTS:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // case actions.FETCH_INCOME_EVENTS_SUCCESS:
    //   return {
    //     ...state,
    //     incomeEvents: {
    //         ...action.payload,
    //     },
    //   };
    // case actions.FETCH_INCOME_EVENTS_ERROR:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
    // case actions.FETCH_EXPENSE_EVENTS:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // // case actions.FETCH_EXPENSE_EVENTS_SUCCESS:
    // //   const expenseEventsContent =
    // //     action.payload &&
    // //     action.payload.map((ee: any) => {
    // //       return {
    // //         value: ee.elements.sourceValue.value,
    // //         name: ee.elements.sourceDisplayName.value,
    // //       };
    // //     });
    // //   return {
    // //     ...state,
    // //     expenseEvents: expenseEventsContent,
    // //   };
    // case actions.FETCH_EXPENSE_EVENTS_SUCCESS:
    //   return {
    //     ...state,
    //     expenseEvents: {
    //         ...action.payload,
    //     },
    //   };
    // case actions.FETCH_EXPENSE_EVENTS_ERROR:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };
        case actions.SET_INITIAL_FUTURE_INCLUDE_IN_SCENARIO:
            return {
                ...state,
                tempScenario: {
                    ...action.payload,
                },
                modelledScenario: {
                    ...action.payload,
                },
                updatedFields: {},
            };
            case actions.UPDATE_FUTURE_INCLUDE_IN_SCENARIO:
            return {
                ...state,
                tempScenario: {
                    ...state.tempScenario,
                    ...action.payload,
                },
                updatedFields: {
                    ...state.updatedFields,
                    ...action.payload,
                },
            };
            case actions.MODEL_FUTURE_INCLUDE_IN_SCENARIO:
                return {
                    ...state,
                    modelledScenario: state.tempScenario,
                };
            default:
                return state;
            }
    };